import {useMutation, useQueryClient} from '@tanstack/react-query'

import {
  createProduct,
  updateProduct,
  linkProductToAccessory,
  unlinkProductFromAccessory,
  bulkProductUpload,
} from './api'
import {productKeys} from './keys'
import {ProductRequest, ProductResponse} from './types'

export const useCreateProduct = () => {
  const queryClient = useQueryClient()

  return useMutation<ProductResponse, unknown, ProductRequest>({
    mutationFn: createProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: productKeys.lists()})
    },
  })
}

export const useUpdateProduct = () => {
  const queryClient = useQueryClient()

  return useMutation<ProductResponse, unknown, {id: string; body: ProductRequest}>({
    mutationFn: ({id, body}) => updateProduct(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: productKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: productKeys.lists()})
    },
  })
}

export const useLinkProductToAccessory = () => {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, {productId: string; accessoryId: string}>({
    mutationFn: ({productId, accessoryId}) => linkProductToAccessory(productId, accessoryId),
    onSuccess: (_, {productId}) => {
      queryClient.invalidateQueries({queryKey: productKeys.detail(productId)})
      queryClient.invalidateQueries({queryKey: productKeys.lists()})
    },
  })
}

export const useUnlinkProductFromAccessory = () => {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, {productId: string; accessoryId: string}>({
    mutationFn: ({productId, accessoryId}) => unlinkProductFromAccessory(productId, accessoryId),
    onSuccess: (_, {productId}) => {
      queryClient.invalidateQueries({queryKey: productKeys.detail(productId)})
      queryClient.invalidateQueries({queryKey: productKeys.lists()})
    },
  })
}

export const useBulkProductUpload = () => {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, string>({
    mutationFn: bulkProductUpload,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: productKeys.lists()})
    },
  })
}
